import {useEffect, useMemo} from 'react';
import {
  FormUser,
  FormGroup,
  FormPIC,
  FormMapSearch,
  FormFolder,
  Confirmation,
  FormRename,
  FormMapFile,
  FormAppAuth,
} from './Center';
import '../../assets/styles/modal.scss';
import FormProgramKerja from './Center/FormProgramKerja';

export default function ModalFlexible({
  type,
  onClose,
  onSubmit,
  data,
  children,
}) {
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.classList.contains('modal_flexible_ctr')) {
        onClose();
        document.removeEventListener('click', handleClick);
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  const handleRender = useMemo(() => {
    switch (type) {
      case 'addUser':
        return <FormUser type={'add'} data={data} onClose={onClose} />;
      case 'editUser':
        return <FormUser type={'edit'} data={data} onClose={onClose} />;
      case 'addGroup':
        return <FormGroup type={'add'} onClose={onClose} />;
      case 'editGroup':
        return <FormGroup type={'edit'} data={data} onClose={onClose} />;
      case 'addPIC':
        return <FormPIC type={'add'} onClose={onClose} />;
      case 'editPIC':
        return <FormPIC type={'edit'} data={data} onClose={onClose} />;
      case 'mapSearch':
        return <FormMapSearch data={data} onClose={onClose} />;
      case 'addFolder':
        return <FormFolder type={'add'} data={data} onClose={onClose} />;
      case 'editFolder':
        return <FormFolder type={'edit'} data={data} onClose={onClose} />;
      case 'rename':
        return (
          <FormRename
            data={data}
            title={data.selected.title}
            onSubmit={data.selected.onSubmit}
            onClose={data.selected.onClose}
          />
        );
      case 'delete':
        return (
          <Confirmation
            text={data.selected.title}
            data={data}
            onClose={data.selected.onClose}
            onSubmit={data.selected.onSubmit}
          />
        );
      case 'programKerja':
        return (
          <FormProgramKerja
            type={data.selected.type}
            data={data}
            onClose={onClose}
          />
        );
      case 'mapFile':
        return <FormMapFile onClose={onClose} data={data} />;
      case 'appAuth':
        return <FormAppAuth onClose={onClose} data={data} />;
      default:
        return children;
    }
  }, [type, data]);
  return <div className='modal_flexible_ctr'>{handleRender}</div>;
}
